import p1 from "./astraReal1";
import p2 from "./astraReal2";
import p3 from "./astraReal3";
import p4 from "./astraReal4";
export const ASTRA_REAL_SRC = `data:image/jpeg;base64,${p1}${p2}${p3}${p4}`;
export default ASTRA_REAL_SRC;
